import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './TourLanding.css';
import logo from './files/LWH TEXT LOGO.png';
import tourLifetimeImg from './files/Tour/tour-lifetime.png';

function TourLandingTemplate({ location, date, photo, photoAlt, flickrUrl }) {
  return (
    <motion.div
      className="tour-landing"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="tour-landing-header">
        <Link to="/" state={{ section: 'tour' }} className="back-link">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Tour
        </Link>
        <img src={logo} alt="Love Works Here" className="landing-logo" />
      </div>

      <div className="tour-landing-content">
        <motion.img
          src={tourLifetimeImg}
          alt="Tour of a Lifetime"
          className="tour-badge"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, duration: 0.5, ease: 'backOut' }}
        />

        <motion.div
          className="tour-details"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.6 }}
        >
          <h1 className="tour-location-title">{location}</h1>
          {date && <div className="tour-date">{date}</div>}
          {photo && (
            <img src={photo} alt={photoAlt || location} className="tour-stop-photo" />
          )}
          {flickrUrl && (
            <a
              className="tour-register-btn tour-album-btn"
              href={flickrUrl}
              target="_blank"
              rel="noreferrer"
            >
              View the Photo Album
            </a>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
}

export default TourLandingTemplate;
